import { ThemeProvider as MUIThemeProvider } from '@mui/material/styles';
import { FC, PropsWithChildren } from 'react';

import globalStylesNode from './globalStyleNode';
import muiTheme from './muiTheme';
import './variables.css';

const Theme: FC<PropsWithChildren> = ({ children }) => {
  return (
    <MUIThemeProvider theme={muiTheme}>
      {globalStylesNode}
      {children}
    </MUIThemeProvider>
  );
};

export default Theme;
